import { render, staticRenderFns } from "./SolidPieForResultForMobile.vue?vue&type=template&id=722dac00&scoped=true&"
import script from "./SolidPieForResultForMobile.vue?vue&type=script&lang=js&"
export * from "./SolidPieForResultForMobile.vue?vue&type=script&lang=js&"
import style0 from "./SolidPieForResultForMobile.vue?vue&type=style&index=0&id=722dac00&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722dac00",
  null
  
)

export default component.exports